import { Button } from '@civilgrid/ui/components';
import type React from 'react';
import { useSnapshot } from 'valtio';
import store from '../../store';
import { stepConfig } from './common';

type ButtonProps = React.ComponentProps<typeof Button>;

export const NextButton = ({ children, disabled, ...props }: ButtonProps) => {
  const {
    formState: { step },
  } = useSnapshot(store);

  return (
    <Button data-testid="request-data-next" disabled={!stepConfig[step + 1] || disabled} {...props}>
      {children ? children : 'Next Step'}
    </Button>
  );
};

export const PreviousButton = ({ children, disabled, ...props }: ButtonProps) => {
  const {
    formState: { step },
  } = useSnapshot(store);
  return (
    <Button
      data-testid="request-data-previous"
      variant="secondary"
      disabled={!stepConfig[step - 1] || disabled}
      {...props}
    >
      {children ? children : 'Previous'}
    </Button>
  );
};
